import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getValidity = (state) => {
    return state.validity;
};
export const getCanUseKiPilotTheory = (state) => {
    return state.canUseKiPilotTheory;
};
export const getYoutubeLink = (state) => {
    return state.youtubeLink;
};
export const getPraxisOverview = (state) => {
    return state.praxisOverview;
};
// KI-Pilot Theory explanations
export const getExplanationLoading = (state) => {
    return state.explanationLoading;
};
export const getExplainVolume = (state) => {
    return state.explainVolume;
};
export const getExplainPreExamPerformance = (state) => {
    return state.explainPreExamPerformance;
};
export const getExplainPerformance = (state) => {
    return state.explainPerformance;
};
export const getExplainGeneralOverview = (state) => {
    return state.explainGeneralOverview;
};
export const getExplainCategory = (state) => {
    return state.explainCategory;
};
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getValidity,
    getCanUseKiPilotTheory,
    getYoutubeLink,
    getPraxisOverview,
    getExplanationLoading,
    getExplainVolume,
    getExplainPreExamPerformance,
    getExplainPerformance,
    getExplainGeneralOverview,
    getExplainCategory,
};
